export default __webpack_public_path__ + "static/media/banner-3.c7681e63.jpg";